<template>
    <div class="modal-content">
        <div style="display: inline-block; width:100%">
            <h3 style="display: inline-block;" slot="header">{{componentprops.header}} &nbsp;&nbsp;</h3>
            <input style="width: 50%;" v-model="email" type="email" name="emailaddress">
        </div>
        <div class="modal-button">

            <button v-if="validate" class="button-box-element btn-agree" @click="send_email(); $emit('disagree')" >{{componentprops.btnPrimary}}</button>
            <button v-else class="button-box-element btn-disabled" disabled >{{componentprops.btnPrimary}}</button>
            <button class="button-box-element btn-disagree" @click="$emit('agree')" >{{componentprops.btnSecondary}}</button>
        </div>
    </div>
</template>
<script>

export default {
	name: "shareModal",
	props: ['componentprops'],
	data() {
		return {
            email: ""
		}
	},
    methods:{
        async send_email(){
            await this.shareWith(this.email, "https://checklist.chillservices.com/#" + this.$route.path )
        }
    },
    computed:{
        validate() {
            return this.email.toLowerCase().match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            ) ? true : false
        }
    }
}
</script>

<style scoped>
    .modal-button {
        display: flex;
        justify-content: space-between;
    }
    .button-box-element {
        width: 130px;
        background-color: #1B608C;
        color: #FFFFFF;
        height: 28px;
        width: 150px;
        border-radius: 28px;
        border: none;
        margin-top: 8px;
    }
    .button-box-element:hover {
        cursor: pointer;
    }
    .btn-agree {
        background-color: #1B608C;

    }
    .btn-disabled {
        background-color: #ECEDF0;
        color: gray;
    }
    .btn-disagree {
        background-color: #ECEDF0;
        color: black;
    }
    .btn-disagree:hover {
        background-color: #E16369;
        color: white;
    }
    button {
        font-family: 'Yantramanav', Verdana, Arial, Helvetica, sans-serif;
    }
</style>